import { Col, Modal, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import InputMoneyWithCheckbox from '../../molecules/InputMoneyWithCheckbox';
import CustomModal from '../../molecules/Modal';

function ModalApplyValuesToAll({ open, onApply, onClose }) {
  const [foodValue, setFoodValue] = useState(0);
  const [mealValue, setMealValue] = useState(0);
  const [shouldApplyToMeal, setShouldApplyToMeal] = useState(false);
  const [shouldApplyToFood, setShouldApplyToFood] = useState(false);

  const confirmAction = () => {
    Modal.confirm({
      icon: null,
      content: (
        <>
          <h2>Aplicar valores a todos</h2>
          <p>Essa função irá alterar os valores de todos os cooperados.</p>
          <br />
        </>
      ),
      okText: 'Confirmar',
      onOk() {
        onApply({
          foodValue,
          mealValue,
          shouldApplyToMeal,
          shouldApplyToFood,
        });
        onClose();
      },
    });
  };

  return (
    <CustomModal
      title="Aplicar valores a todos"
      okText="Aplicar"
      cancelText="Cancelar"
      onCancel={onClose}
      onOk={confirmAction}
      open={open}
    >
      <p>Esses valores serão aplicados a todos os colaboradores</p>
      <Row
        type="flex"
        gutter={[16, 16]}
      >
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          xxl={12}
        >
          <InputMoneyWithCheckbox
            label="VA / Período"
            moneyValue={foodValue}
            onChangeMoneyValue={(value) => setFoodValue(value)}
            isInputEnabled={shouldApplyToFood}
            onChangeCheckbox={(value) => setShouldApplyToFood(value)}
          />
        </Col>
        <Col
          xs={24}
          sm={24}
          md={24}
          lg={12}
          xl={12}
          xxl={12}
        >
          <InputMoneyWithCheckbox
            label="VR / Período"
            onChangeMoneyValue={(value) => setMealValue(value)}
            moneyValue={mealValue}
            isInputEnabled={shouldApplyToMeal}
            onChangeCheckbox={(value) => setShouldApplyToMeal(value)}
          />
        </Col>
      </Row>
      <br />
      <p>Obs.: Essa função irá alterar os valores de todos os cooperados.</p>
    </CustomModal>
  );
}

ModalApplyValuesToAll.propTypes = {
  open: PropTypes.bool.isRequired,
  onApply: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ModalApplyValuesToAll;
